import {ErrorNotice} from '../../components';

export function SystemError() {
    return <ErrorNotice />;
}
